(() => {
  if (window.lunaMotionReady) return;
  window.lunaMotionReady = true;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = preference.matches;
  let celebrationTimer;
  let lastCelebration = 0;
  const clearCelebration = () => {
    window.clearTimeout(celebrationTimer);
    document.querySelector('.luna-cart-celebration')?.remove();
  };
  // Decoration only: the existing forms, uploader and cart own the purchase.
  const celebrateCartAdd = (event) => {
    const detail = event.detail;
    const source = detail?.data?.source;
    if (detail?.data?.didError || !['product-form-component', 'odemly-cart-sync'].includes(source)) return;
    if (paused || preference.matches || Date.now() - lastCelebration < 1800) return;
    lastCelebration = Date.now();
    clearCelebration();
    const stamp = document.createElement('span');
    stamp.className = 'luna-cart-celebration';
    stamp.setAttribute('aria-hidden', 'true');
    stamp.innerHTML = '<svg viewBox="0 0 32 32" fill="none"><path d="m8 16 5 5 11-12" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.append(stamp);
    celebrationTimer = window.setTimeout(clearCelebration, 1600);
  };
  const sync = () => {
    if (paused) clearCelebration();
    document.body.dataset.lunaMotion = paused ? 'paused' : 'playing';
    document.querySelectorAll('[data-luna-motion-toggle]').forEach((button) => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    });
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-luna-motion-toggle]')) return;
    paused = !paused;
    sync();
  });
  preference.addEventListener('change', (event) => { paused = event.matches; sync(); });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('cart:update', celebrateCartAdd);
  window.addEventListener('pagehide', clearCelebration);
  sync();
})();
